export default "__VITE_ASSET__BS5QzOar__"